import React, { Component } from "react";
import Dots from "react-activity/lib/Dots";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";
import Button from "react-bootstrap/Button";

import { getSponsors, deleteSponsor } from "../../services/sponsorService";
import { SponsorCard } from "./sponsorCard";

class SponsorsList extends Component {
  state = {
    sponsors: [],
    loaded: true,
  };

  async componentDidMount() {
    await this.loadSponsors();
  }

  async loadSponsors() {
    this.setState({ loaded: false });

    const sponsors = await getSponsors();

    this.setState({ sponsors, loaded: true });
  }

  handleAddSponsor = () => {
    this.props.history.push(`/sponsor/add`);
  };

  handleEditSponsor = (sponsor_id) => {
    this.props.history.push(`/sponsor/edit/${sponsor_id}`);
  };

  handleDeleteSponsor = async (sponsor_id) => {
    await deleteSponsor(sponsor_id);
    await this.loadSponsors();
  };

  render() {
    const { sponsors, loaded } = this.state;

    return loaded === false ? (
      <div className="dots_loader">
        <Dots size={26} />
      </div>
    ) : (
      <React.Fragment>
        <div
          className="row"
          style={{
            width: "600px",
            border: "1px solid darkgray",
            padding: "20px",
            margin: "auto",
          }}
        >
          <div className="col-8">
            <h4 style={{ marginBottom: 20 }}>
              <FontAwesomeIcon icon="dollar-sign" />
              &nbsp;SPONSORS
            </h4>
          </div>
          <div className="col-4">
            <Button variant="link" onClick={() => this.handleAddSponsor()}>
              Add Sponsor
            </Button>
          </div>
          <hr style={{ marginTop: 0, padding: 0 }} />
          {sponsors.map((sponsor, index) => (
            <SponsorCard
              key={index}
              sponsor={sponsor}
              onEditSponsor={this.handleEditSponsor}
              onDeleteSponsor={this.handleDeleteSponsor}
            />
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(SponsorsList);
